<div class="m-form-field">
  <div class="a-datetime-input">
    <label *ngIf="label" [for]="id"> {{ label }} <ng-container *ngIf="isRequired$ | async">*</ng-container> </label>

    <input
      [id]="id"
      [formControl]="control"
      [placeholder]="placeholder"
      [readonly]="readonly"
      [disabled]="isDisabled$ | async"
      type="datetime-local"
      #input
    />
    <button type="button" class="a-datetime-input__button" aria-label="open dialog" (click)="showPicker()">
      <bosch-ui-icon [name]="iconNames.CalendarClock"></bosch-ui-icon>
    </button>
  </div>
  <bosch-ui-validation-error
    *ngIf="!errorRef && (error$ | async) as error"
    [error]="'common.validation.error.' + error | translate"
  ></bosch-ui-validation-error>
  <ng-container *ngIf="errorRef">
    <ng-content></ng-content>
  </ng-container>
</div>
